export default "__VITE_ASSET__7aIRmiuJ__"